import Lottie from 'lottie-react';
import { Outlet } from 'react-router-dom';

import landingAnimation from '@/assets/animations/landing-animation.json';
import usePlatform from '@/hooks/use-platform';

import CustomContent from '../AppLayout/CustomContent';

import styles from './index.module.scss';

const LandingSplitLayout = () => {
  const { isMobile } = usePlatform();

  return (
    <div className={styles.viewport}>
      <CustomContent className={styles.customContent} keyPrefix="landing:" />
      <div className={styles.panels}>
        {!isMobile && (
          <div className={styles.leftPanel}>
            <Lottie
              loop
              autoplay
              animationData={landingAnimation}
              rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
              className={styles.animation}
            />
          </div>
        )}
        <div className={styles.rightPanel}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LandingSplitLayout;
